import { useEffect } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';

export interface Props {
  destination: string;
}

export const RedirectTo = ({ destination = '/' }: Props) => {
  const [, { navigate }] = useNavigation();

  useEffect(() => {
    navigate(destination);
  }, [destination, navigate]);

  return null;
};
